import {AfterViewInit, Directive, ElementRef, Input, OnDestroy} from '@angular/core';
import {BorderGradientColor} from "../ts-types/border-gradient-color";

@Directive({
  selector: '[brtBorderGradient]'
})
export class BorderGradientDirective implements AfterViewInit, OnDestroy {

  @Input('color') color: BorderGradientColor = "midnight";

  resizeObserver!: ResizeObserver;

  private readonly _svgHtmlString = `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 %%width%% %%height%%" preserveAspectRatio="none" style="
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    /* border-radius: 100%; */
    overflow: visible;
    /* box-sizing: border-box; */
">
    <defs>
      <linearGradient id="gradient" gradientTransform="rotate(-180)">
        <animateTransform
          attributeName="gradientTransform"
          type="rotate"
          from="-180"
          to="180"
          dur="10s"
          repeatCount="indefinite"
        />
        <stop offset="0" style="stop-color:#6041FF" stop-opacity="0"></stop>
        <stop offset="50%" style="stop-color:#6041FF" stop-opacity="1"></stop>
      </linearGradient>
    </defs>
    <g transform="ref(svg, 0, 0)">
      <rect x="0" y="0" width="100" height="100" rx="2" ry="2" fill="none" stroke="url(#gradient)" stroke-width="0.1" style="
    width: 100%;
    height: 100%;
    stroke-width: 0.2px;
    /* border-radius: 100%; */
"></rect>
    </g>
  </svg>`;

  private readonly  svgHtmlString = `<svg xmlns="http://www.w3.org/2000/svg" class="svg-border-gradient" width="100%" height="100%" viewBox="0 0 %%width%% %%height%%" preserveAspectRatio="none">
    <g transform="ref(svg, 0, 0)">
      <rect x="1px" y="1px" width="100" height="100" rx="16" ry="16" fill="none" stroke="url(#%%gradient_id%%)" stroke-width="0.1" style="
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    stroke-width: 1px;
    /* border-radius: 100%; */
"></rect>
    </g>
  </svg>`;

  private static gradients: {color:  BorderGradientColor; linearGradientString: string, added: boolean}[] = [
    {
      color: "midnight",
      linearGradientString: `<svg xmlns="http://www.w3.org/2000/svg" style="height: 0; position: absolute; transform-origin: 0 50%;"><linearGradient id="gradient_midnight" gradientTransform="rotate(0)">

        <stop offset="0" style="stop-color:#6041FF" stop-opacity="0"></stop>
        <stop offset="50%" style="stop-color:#6041FF" stop-opacity="1"></stop>
      </linearGradient></svg>`,
      added: false
    },
    {
      color: "orange",
      linearGradientString: `<svg xmlns="http://www.w3.org/2000/svg" style="height: 0; position: absolute; transform-origin: 0 50%;"><linearGradient id="gradient_orange" gradientTransform="rotate(0)">

        <stop offset="0" style="stop-color:#FFA644" stop-opacity="0"></stop>
        <stop offset="50%" style="stop-color:#FFA644" stop-opacity="1"></stop>
      </linearGradient></svg>`,
      added: false
    },
    {
      color: "green",
      linearGradientString: `<svg xmlns="http://www.w3.org/2000/svg" style="height: 0; position: absolute; transform-origin: 0 50%;"><linearGradient id="gradient_green" gradientTransform="rotate(0)">

        <stop offset="0" style="stop-color:#3FDB47" stop-opacity="0"></stop>
        <stop offset="50%" style="stop-color:#3FDB47" stop-opacity="1"></stop>
      </linearGradient></svg>`,
      added: false
    },
    {
      color: "blue",
      linearGradientString: `<svg xmlns="http://www.w3.org/2000/svg" style="height: 0; position: absolute; transform-origin: 0 50%;"><linearGradient id="gradient_blue" gradientTransform="rotate(0)">

        <stop offset="0" style="stop-color:#4710E3" stop-opacity="0"></stop>
        <stop offset="50%" style="stop-color:#4710E3" stop-opacity="1"></stop>
      </linearGradient></svg>`,
      added: false
    }
  ]
  constructor(private el: ElementRef) {

  }

  ngAfterViewInit() {
    return;
    const htmlHostEl = this.el.nativeElement as HTMLElement;

    const htmlHostElStyle = window.getComputedStyle(htmlHostEl);
    const currentPositionStyle = htmlHostElStyle.getPropertyValue("position");

    if(currentPositionStyle !== "absolute" && currentPositionStyle !== "fixed") {
      htmlHostEl.style.position = "relative";
    }
    const svgStr = this.svgHtmlString;
    const targetGradient = BorderGradientDirective.gradients.filter((el) => el.color === this.color);
    if(targetGradient.length) {
      if(!targetGradient[0].added) {
        targetGradient[0].added = true;
        htmlHostEl.insertAdjacentHTML('afterbegin', targetGradient[0].linearGradientString);
      }
    }

    const hostElWidth = htmlHostEl.clientWidth;
    const hostElHeight = htmlHostEl.clientHeight;

    let svgStrReplace = svgStr.replaceAll("%%gradient_id%%", "gradient_" + this.color);
    svgStrReplace = svgStrReplace.replaceAll("%%width%%", hostElWidth.toString());
    svgStrReplace = svgStrReplace.replaceAll("%%height%%", hostElHeight.toString());

    htmlHostEl.insertAdjacentHTML('afterbegin', svgStrReplace);

    this.resizeObserver = new ResizeObserver(entries => {
      if(entries.length > 0) {
        const entry = entries[0];

        let parentHtmlEl = this.el.nativeElement as HTMLElement;
        const svgEl = parentHtmlEl.querySelector(".svg-border-gradient");
        if(svgEl) {
          svgEl.setAttribute('viewBox', `0 0 ${entry.borderBoxSize[0].inlineSize} ${entry.borderBoxSize[0].blockSize}`);

          svgEl.remove();
          parentHtmlEl.appendChild(svgEl);
        }
      }
    });
    this.resizeObserver.observe(this.el.nativeElement as HTMLElement);
  }

  ngOnDestroy() {
    if(this.resizeObserver !== undefined) {
      this.resizeObserver.disconnect();
    }
  }

}
